// Блок "Стоимость" на главной
itsoftApp.createModule("priceScripts", function() {

    // Клик по региону и добавление его в кастомный инпут.
    $(".price-select__link").on("click", function() {
        var thInner = $(this).html(),
            thDataVal = $(this).attr("data-value"),
            inputCountry = $(this).closest(".price-select").find(".price-select__country");

        inputCountry.html("");
        inputCountry.html(thInner);
        inputCountry.attr("data-value", thDataVal);

        selectBox();
        togglePrice($(this));
    });

    itsoftApp.loadStyle("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.css");
    itsoftApp.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js", function() {

        (function( $ ) {
            $.widget( "custom.combobox", {
              _create: function() {
                this.wrapper = $( "<span>" )
                  .addClass( "custom-combobox" )
                  .insertAfter( this.element );

                this.element.hide();
                this._createAutocomplete();
                this._createShowAllButton();
              },

              _createAutocomplete: function() {
                var selected = this.element.children( ":selected" ),
                  value = selected.val() ? selected.text() : "";

                this.input = $( "<input>" )
                  .appendTo( this.wrapper )
                  .val( value )
                  .attr( "title", "" )
                  .addClass( "custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left" )
                  .autocomplete({
                    delay: 0,
                    minLength: 0,
                    source: $.proxy( this, "_source" )
                  })
                  .tooltip({
                    tooltipClass: "ui-state-highlight"
                  });

                this._on( this.input, {
                  autocompleteselect: function( event, ui ) {
                    ui.item.option.selected = true;
                    this._trigger( "select", event, {
                      item: ui.item.option
                    });
                  },

                  autocompletechange: "_removeIfInvalid"
                });
              },

              _createShowAllButton: function() {
                var input = this.input,
                  wasOpen = false;

                $( "<a>" )
                  .attr( "tabIndex", -1 )
                  //.attr( "title", "Show All Items" )
                  .tooltip()
                  .appendTo( this.wrapper )
                  .button({
                    icons: {
                     // primary: "glyphicon glyphicon-triangle-bottom"
                    },
                    text: false
                  })
                  .removeClass( "ui-corner-all" )
                  .addClass(  "custom-combobox-toggle glyphicon glyphicon-triangle-bottom" )
                  .mousedown(function() {
                    wasOpen = input.autocomplete( "widget" ).is( ":visible" );
                  })
                  .click(function() {
                    input.focus();

                    // Close if already visible
                    if ( wasOpen ) {
                      return;
                    }

                    // Pass empty string as value to search for, displaying all results
                    input.autocomplete( "search", "" );
                  });
              },

              _source: function( request, response ) {
                var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
                response( this.element.children( "option" ).map(function() {
                  var text = $( this ).text();
                  if ( this.value && ( !request.term || matcher.test(text) ) )
                    return {
                      label: text,
                      value: text,
                      option: this
                    };
                }) );
              },

              _removeIfInvalid: function( event, ui ) {

                // Selected an item, nothing to do
                if ( ui.item ) {
                  return;
                }

                // Search for a match (case-insensitive)
                var value = this.input.val(),
                  valueLowerCase = value.toLowerCase(),
                  valid = false;
                this.element.children( "option" ).each(function() {
                  if ( $( this ).text().toLowerCase() === valueLowerCase ) {
                    this.selected = valid = true;
                    return false;
                  }
                });

                // Found a match, nothing to do
                if ( valid ) {
                  return;
                }

                // Remove invalid value
                this.input
                  .val( "" )
                  .attr( "title", value + " не найдено." )
                  .tooltip( "open" );
                this.element.val( "" );
                this._delay(function() {
                  this.input.tooltip( "close" ).attr( "title", "" );
                }, 2500 );
                this.input.autocomplete( "instance" ).term = "";
              },

              _destroy: function() {
                this.wrapper.remove();
                this.element.show();
              }
            });
          })( jQuery );

          $(function() {
            $( "#combobox" ).combobox();
            $( "#toggle" ).click(function() {
              $( "#combobox" ).toggle();
            });
          });

    });

    // Выбор региона из селекта и запись в главное поле
    $(document).on("click", ".ui-menu-item", function() {
        var thInner = $(".custom-combobox-input").val(),
            thDataVal,
            inputCountry = $(".price-select__country");
            console.log("thInner " + thInner);

        $("#combobox option").each(function() {
            console.log("1");
            if ($(this).html() == thInner) {
                thDataVal = $(this).attr("value");
                console.log("thDataVal " + thDataVal);
            }
        });

        inputCountry.html("");
        inputCountry.html(thInner);
        inputCountry.attr("data-value", thDataVal);

        selectBox();
        $(".price-select").toggleClass("is-active");
    });

    // Проверка выбранного региона и отображение
    // price-container__box с соответствующим значением
    function selectBox() {
        var selectVal = $(".price-select__country").attr("data-value");

        $(".price-container__box").removeClass("is-active");

        $(".price-container__box").each(function() {
            if (selectVal == $(this).attr("data-index")) {
                $(this).addClass("is-active");
            }
        });
    }

    // Открытие кастомного селекта
    $(".price-select__input").click(function() {
        togglePrice($(this));
    });

    var checkToggle = true;
    function togglePrice(e) {
        if (checkToggle) {
            e.closest(".price-select").toggleClass("is-active");
            checkToggle = false;
            setTimeout(function() {
                checkToggle = true;
            }, 600);
        }
    }

    // Переключение закладок
    $(".price__button").click(function() {
        if ($(this).hasClass("is-active")) {
            return false;
        }
        else {
            $(this).closest(".price__buttons-block").find(".price__button").removeClass("is-active");
            $(this).addClass("is-active");

            var thIndex = $(this).attr("data-index");

            $(".price__content-toggle").removeClass("is-active");
            $(".price__content-toggle").fadeOut(0);
            $(".price__content-toggle").each(function() {
                if (thIndex == $(this).attr("data-index")) {
                    $(this).addClass("is-active");
                    $(this).css("display", "flex").hide().fadeIn(300);
                }
            });
        }

    });

});
